import { render, staticRenderFns } from "./ConnectWithModalButton.vue?vue&type=template&id=e652d1b8&scoped=true&"
import script from "./ConnectWithModalButton.vue?vue&type=script&lang=js&"
export * from "./ConnectWithModalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e652d1b8",
  null
  
)

export default component.exports